import React from 'react';
import { pains } from '../data/content';
export function PainSection() {
  return <section className="bg-brand-cream px-4 py-5 sm:px-6" aria-labelledby="pain-heading" data-id="element-110" data-mp="38xoher0tacsw">
      <h2 id="pain-heading" className="mb-2 text-center text-xl font-extrabold uppercase leading-tight text-brand-navy sm:text-3xl" data-id="element-111" data-mp="2uy5mx10xazz2">
        Does This Sound Familiar?
      </h2>
      <p className="mb-1 text-center text-[12px] font-medium leading-snug text-brand-ink sm:text-sm" data-id="element-112" data-mp="2l8c9duh80as6">
        You became a pickleball coach because you love teaching and helping players improve... But
        coaching requires much more than simply showing up on court. Every week you need new
        sessions. New drills. Clear progressions. Different options for different levels. And a plan
        for what each player should work on next.
      </p>
      <p className="mb-3 text-center text-[12px] font-bold leading-snug text-brand-navy sm:text-sm" data-id="element-113" data-mp="22a00m9u812x4">
        Whether you coach private lessons, groups, clinics, recreational players, or competitive
        players... You've probably experienced at least one of these situations.
      </p>
      <div className="space-y-2" data-id="element-114" data-mp="3nknq920v96d1">
        {pains.map(pain => <article key={pain.title} className="flex gap-2.5 rounded-lg border-l-4 border-brand-green bg-white p-3 shadow-sm" data-id="element-115" data-mp="5gccuh1dm7xm">
            <span className="text-lg leading-none" aria-hidden="true" data-id="element-116" data-mp="emwqmzar42o">
              {pain.emoji}
            </span>
            <div data-id="element-117" data-mp="33xgb31zwfwxw">
              <h3 className="mb-0.5 text-[13px] font-extrabold leading-tight text-brand-navy sm:text-base" data-id="element-118" data-mp="33xyd6f98t5dq">
                {pain.title}
              </h3>
              <p className="text-[11px] font-medium leading-snug text-brand-ink/80 sm:text-xs" data-id="element-119" data-mp="3iofelylvnvam">
                {pain.lines.join(' ')}
              </p>
            </div>
          </article>)}
      </div>
    </section>;
}